// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-left-20[data-v-00be77a8]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
